import {color} from "@khanacademy/wonder-blocks-tokens";
import {mediaQueries, pageHeaderHeight} from "@khan/shared-styles";

import {domainColors} from "#content-library-legacy/styles/shared.ts";
import {
    moduleHorizontalPadding,
    moduleHorizontalPaddingSmall,
    moduleVerticalPadding,
    moduleVerticalPaddingSmall,
    moduleWidthCentered,
} from "#modules-package/styles.ts";
// eslint-disable-next-line no-restricted-imports -- TODO: Replace this component with the equivalent one from Wonder Blocks.
import {deprecatedTypography} from "#shared-styles-package/deprecated-typography.ts";

const styles = {
    headerWrapper: {
        paddingTop: pageHeaderHeight,
        backgroundColor: domainColors("default").domain1,
    },
    contentModule: {
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: moduleVerticalPadding,
        paddingLeft: moduleHorizontalPadding,
        paddingRight: moduleHorizontalPadding,
        paddingTop: 0,

        [mediaQueries.smOrSmaller]: {
            paddingBottom: moduleVerticalPaddingSmall,
            paddingLeft: moduleHorizontalPaddingSmall,
            paddingRight: moduleHorizontalPaddingSmall,
            paddingTop: moduleVerticalPaddingSmall,
        },
        maxWidth: moduleWidthCentered,
        textAlign: "center",
        color: color.white,
    },
    title: {
        ...deprecatedTypography.subheadingDesktop,
        color: color.white,
        marginBottom: 16,
        fontSize: 34,
    },
    description: {
        ...deprecatedTypography.bodyLarge,
        marginBottom: 16,
    },
    content: {
        fontSize: 16,
        margin: "auto",
        maxWidth: 560,
        marginBottom: 60,

        [mediaQueries.smOrSmaller]: {
            margin: "2em 1em",
        },
    },
    thumbnailsContainer: {
        display: "flex",
        padding: "0 1em",
        margin: "0 -1em 3em -2em",

        [mediaQueries.smOrSmaller]: {
            display: "block",
        },
    },
    thumbnailText: {
        margin: "1em 0em",
        textAlign: "center",
    },
} as const;

export default styles;
